import { render, staticRenderFns } from "./UnsubscribeModule.vue?vue&type=template&id=432763ae&"
import script from "./UnsubscribeModule.ts?vue&type=script&lang=ts&"
export * from "./UnsubscribeModule.ts?vue&type=script&lang=ts&"
import style0 from "./UnsubscribeModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports